import { useEffect, useRef, useState } from "react";
import { useLanguage } from "./../../context/Languagecontext";
import './LanguageSelector.css';
import { Globals as OldGlobals } from "../../global/Globals";

const LanguageSelector = (props) => {
    const { Globals, languages, setLanguages } = useLanguage();
    const [isopen, SetIsopen] = useState(false);
    const dropdownRef = useRef(null);

    const onDropdownClick = () => {
        SetIsopen(prev => !prev);
    };

    const handleChange = (selectedLang, e) => {
        e.stopPropagation();
        SetIsopen(false);
        localStorage.setItem("lang", selectedLang);
        setLanguages(selectedLang); // trigger re-render
        window.dispatchEvent(new Event("storage")); // ensure same-tab update
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            SetIsopen(false);
        }
    }
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            <div ref={dropdownRef} className={`dropdown ${props.ishome ? "languageSelector" : "languageSelector-small"}`} onClick={onDropdownClick}>
                <div className="languageselected">
                    <div className="langimg"><img src={Globals.IMG.LANG_SELECT} /></div>
                    {props.ishome &&
                        <div>
                            <div className="selectedlang">{OldGlobals[languages]}</div>
                        </div>
                    }
                    {isopen &&
                        <div className="dropdown-content">
                            <div className="dropdownItem" onClick={(e) => handleChange("en", e)}>English  {languages === "en" && (
                                <div className="blue-check-wrapper">
                                    <img className="blue-check" src={Globals.IMG.BLUE_CHECK} />
                                </div>
                            )}</div>
                            <div className="dropdownItem" onClick={(e) => handleChange("pt", e)}>Portuguese  {languages === "pt" && (
                                <div className="blue-check-wrapper">
                                    <img className="blue-check" src={Globals.IMG.BLUE_CHECK} />
                                </div>
                            )}</div>
                            <div className="dropdownItem" onClick={(e) => handleChange("ah", e)}>Amharic  {languages === "ah" && (
                                <div className="blue-check-wrapper">
                                    <img className="blue-check" src={Globals.IMG.BLUE_CHECK} />
                                </div>
                            )}</div>
                            <div className="dropdownItem" onClick={(e) => handleChange("kw", e)}>Kiswahili  {languages === "kw" && (
                                <div className="blue-check-wrapper">
                                    <img className="blue-check" src={Globals.IMG.BLUE_CHECK} />
                                </div>
                            )}</div>
                        </div>
                    }
                </div>
            </div>
        </>
    )
};

export default LanguageSelector
